import {
  decorativeElementsClass,
  outerShadowElementsClass,
  wheelBorderClass
} from '~/actions/extraHTML/wheelOfFortune/const';

export const decorativeElements = (radius: number) => {

  return `
          <div class='${outerShadowElementsClass}'></div>
          <div class='${decorativeElementsClass}'></div>
          <div class='${wheelBorderClass}'></div>
`;
};
